import React from 'react';
import { useNavigate } from 'react-router-dom';
import useAuth from '../hooks/useAuth';

const ProtectedRoute = ({ children, requiredUserType = null }) => {
  const { isAuthenticated, userType, isLoading } = useAuth();
  const navigate = useNavigate();

  // Afficher un loader pendant la vérification
  if (isLoading) {
    return (
      <div style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100vh',
        fontSize: '18px'
      }}>
        Vérification de l'authentification...
      </div>
    );
  }

  // Si pas authentifié, rediriger directement
  if (!isAuthenticated) {
    console.log('🚨 ProtectedRoute: Non authentifié, redirection...');
    navigate('/login', { replace: true });
    return (
      <div style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100vh',
        fontSize: '18px'
      }}>
        Redirection vers la page de connexion...
      </div>
    );
  }

  // Si un type d'utilisateur spécifique est requis
  if (requiredUserType && userType !== requiredUserType) {
    console.log(`🚨 ProtectedRoute: Type incorrect. Requis: ${requiredUserType}, Actuel: ${userType}`);
    navigate('/login', { replace: true });
    return (
      <div style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100vh',
        fontSize: '18px',
        color: 'red'
      }}>
        Accès non autorisé. Redirection...
      </div>
    );
  }

  // Si tout est OK, afficher le composant enfant
  return children;
};

export default ProtectedRoute;